import React, {useEffect, useState} from 'react';
import {ToastContainer} from 'react-toastify';
import AppLoader from '../HelperClasses/AppLoaderClasses/AppLoader';
import HeaderView from '../Settings/HeaderView';
import ToastPopup from '../HelperClasses/AppLoaderClasses/ToastPopup';
import {checkUserForm} from './actions/checkUserForm';
import TextInput from '../UI/Form/TextInput';
import {onUserSubmit} from './actions/OnUserSubmit';
import {CONFIG_CONSTANT} from '../Constants/ConfigsConstants';

const CreateUser = ({closeModal, load_users}) => {
  const [form_state, setFormState] = useState({
    uuid: '',
    username: '',
    email: '',
    first_name: '',
    last_name: '',
    type: 'customer',
    auth_type: CONFIG_CONSTANT.GENERAL_CONFIGS.auth_type,
  });
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className="  w-full h-full py-4">
      <HeaderView
        title={'Create New User'}
        saveBtnTitle={'Save'}
        isBeta={true}
        saveBtn={() => {
          if (isLoading) {
            ToastPopup({type: 'warning', message: 'Please wait...'});
          } else {
            const checkup = checkUserForm({
              form_data: form_state,
            });

            if (checkup) {
              onUserSubmit({
                form_state,
                setIsLoading,
                closeModal,
              });
            }
          }
        }}
        backBtn={() => closeModal()}
      />
      {/* Cretae*/}
      <div className="   h-fit border border-gray-200 rounded-md py-4 px-5 w-[97%] m-3 flex flex-col gap-3  ">
        <>
          {/* Username */}
          <TextInput
            title={'Email'}
            current_data={form_state?.email}
            placeholder={'Email'}
            type={'text'}
            update_data={data => setFormState({...form_state, email: data})}
            isRequired={true}
            isDisabled={form_state?.is_user_selected}
          />

          {/* First Name */}
          <TextInput
            title={'First Name'}
            current_data={form_state?.first_name}
            placeholder={'First Name'}
            type={'text'}
            update_data={data =>
              setFormState({...form_state, first_name: data})
            }
            isRequired={true}
            isDisabled={form_state?.is_user_selected}
          />

          {/* Last Name */}
          <TextInput
            title={'Last Name'}
            current_data={form_state?.last_name}
            placeholder={'Last Name'}
            type={'text'}
            update_data={data => setFormState({...form_state, last_name: data})}
            isRequired={true}
            isDisabled={form_state?.is_user_selected}
          />
        </>
      </div>

      <ToastContainer />
      <AppLoader enable={!isLoading} />
    </div>
  );
};

export default CreateUser;
